module.exports = __webpack_public_path__ + "img/honor9.8272fba7.jpg";